import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = ["rgb(var(--success))", "rgb(var(--danger))"];

const ChartSemiPie = ({ summaryData }) => {
  const cobrado = Number(summaryData?.data?.cobrado ?? 0);
  const porCobrar = Number(summaryData?.data?.porCobrar ?? 0);
  const total = cobrado + porCobrar;
  
  const data = [
    { name: "Cobrado", value: cobrado },
    { name: "Por Cobrar", value: porCobrar },
  ];

  const percentage = total > 0 ? ((cobrado / total) * 100).toFixed(0) : 0;

  return (
    <ResponsiveContainer width="100%" height={215}>
      <PieChart>
        <Pie
         data={data}
         cx="50%"
         cy="80%"            // 1) Centro en el fondo del contenedor
         startAngle={180}
         endAngle={0}
         innerRadius="60%"     // 2) Radio relativo al contenedor
         outerRadius="80%"     //    así nunca sale fuera
         paddingAngle={0}      // 3) Quitar el padding entre slices
        
         dataKey="value"
         isAnimationActive={false}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index]} />
          ))}
        </Pie>
        {/* Porcentaje en el centro */}
        <text x="50%" y="70%" textAnchor="middle" dominantBaseline="central" fontSize={24} fontWeight="bold" fill="rgb(var(--text))">
          {percentage}%
        </text>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ChartSemiPie
